<template>
  <div class="connect-with-interpreter d-flex flex-column">
    <ConveyConnectSDK />
  </div>
</template>

<script>
/* eslint-disable */
import ConveyConnectSDK from './ConveyConnectSDK';

export default {
  name: "ConnectWithInterpreter",
  components: { ConveyConnectSDK },
  created() {},
};
</script>

<style lang="scss" scoped>
.connect-with-interpreter {
  &__actions {
    > div {
      width: calc(50% - 8px);
    }
  }
}
</style>